import React from "react";
import { useState } from "react";
import cn from "classnames";
import { ReactComponent as Heart } from "../svg/heart-regular.svg";
import { ReactComponent as HeartSolid } from "../svg/heart-solid.svg";

const LikeButton = (props) => {
  const [liked, setLiked] = useState(null);
  const [clicked, setClicked] = useState(false);

  return (
    <span className="svg">
      <Heart
        onClick={() => {
          setLiked(!liked);
          setClicked(true);
          props.likePost;
        }} 
        onAnimationEnd={() => setClicked(false)}
        className="like-button-wrapper"
      />
      <HeartSolid className={cn("like-button-wrapper solid", {liked, clicked})} />
    </span>
  );
};

export default LikeButton;